import { canTrack } from "./googleTracking";

export function isAdMeasurementOptedOut() {
  if (typeof document === "undefined") return true;
  return window.navigator?.globalPrivacyControl === true ||
    window.navigator?.doNotTrack === "1" ||
    /(?:^|;\s*)alpha_ad_measurement=denied(?:;|$)/.test(document.cookie);
}

export function captureOpenAIReference() {
  if (!canTrack()) return;
  if (isAdMeasurementOptedOut()) {
    document.cookie = "alpha_oppref=; Max-Age=0; Path=/; SameSite=Lax; Secure";
    return;
  }
  const ref = new URL(window.location.href).searchParams.get("oppref");
  if (ref && ref.length <= 4096 && /^[A-Za-z0-9_=-]+$/.test(ref)) {
    document.cookie = `alpha_oppref=${ref}; Max-Age=2592000; Path=/; SameSite=Lax; Secure`;
  }
}

const lastContactClicks = new Map();
export function trackOpenAIContact(kind) {
  if (!canTrack() || isAdMeasurementOptedOut() ||
      !["phone_click", "email_click"].includes(kind)) return;
  captureOpenAIReference();
  if (!/(?:^|;\s*)alpha_oppref=/.test(document.cookie)) return;
  const now = Date.now();
  if (now - (lastContactClicks.get(kind) || 0) < 10000) return;
  lastContactClicks.set(kind, now);
  try {
    // keepalive lets tel/mailto navigation proceed immediately.
    fetch("/api/ad-contact", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ kind, eventId: window.crypto.randomUUID() }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* Tracking must never interrupt contact links. */ }
}
